import React from "react";
import { Route, RouteChildrenProps } from "react-router-dom";
import { Drawer } from "@material-ui/core";

interface Props {
  onClose: () => void;
  path: string;
  render: (routeProps: RouteChildrenProps<any, unknown>) => React.ReactNode;
  exact?: boolean;
}

export const DriverLogViewChildRoute = ({
  path,
  exact,
  onClose,
  render,
}: Props) => {
  return (
    <Route exact={exact} path={path}>
      {(routeProps) => {
        const isMatch = routeProps.match && !!routeProps.match.params;

        return (
          <Drawer open={isMatch ?? false} anchor="right" onClose={onClose}>
            {isMatch ? render(routeProps) : <div />}
          </Drawer>
        );
      }}
    </Route>
  );
};
